import {Suspense} from "react";

import Script from "next/script";

import type {AppProps} from "next/app";
import {ThemeProvider} from "@mui/material/styles";
import "../styles/globals.css";

import {BookingProvider} from "../contexts/HVBContext";

import theme from "../styles/theme";

// ==================================================
function BookingApp({Component, pageProps}: AppProps) {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Script id="facebook-pixel">
          {`
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '772558155381730'); // Chris Powell Pixel
                fbq('init', '779664209285691'); // Base Pixel
                fbq('init', '195949191612596'); // Longevity USA Pixel
                fbq('track', 'PageView');
              `}
        </Script>
        <Script id="gtm">{`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-P52ZQ7L');
          `}
        </Script>
        <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-P52ZQ7L"
            height="0"
            width="0"
            style={{display: "none", visibility: "hidden"}}
          ></iframe>
        </noscript>
        <Script id="shareasale" src="https://www.dwin1.com/19038.js" defer={true}></Script>
        <Script id="nextdoor">
          {`
          (function(win, doc, sdk_url){
            if(win.ndp) return;
            var tr=win.ndp=function(){
            tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
           };
            tr.queue = [];
            var s='script';
            var new_script_section=doc.createElement(s);
            new_script_section.async=!0;
            new_script_section.src=sdk_url;
            var insert_pos=doc.getElementsByTagName(s)[0];
           insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
           })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');
           
            ndp('init', 'f288127b-9e25-4496-8827-826c2ee66011', {})
           
            ndp('track','PAGE_VIEW');
        `}
        </Script>
        <noscript>
          <img
            alt=""
            height="1"
            width="1"
            style={{display: "none"}}
            src={`https://flask.nextdoor.com/pixel?pid=f288127b-9e25-4496-8827-826c2ee66011&ev=PAGE_VIEW&noscript=1`}
          />
        </noscript>
        <Script id="clarity-script">
          {`
            if (window.location.hostname === 'schedule.thrivelab.com') {
              (function(c,l,a,r,i,t,y){
                  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
              })(window, document, "clarity", "script", "sywxiq2df7");
            }
          `}
        </Script>
        <Script id="pinterest">
          {`
          !function(e){if(!window.pintrk){window.pintrk = function () {
          window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
          n=window.pintrk;n.queue=[],n.version="3.0";var
          t=document.createElement("script");t.async=!0,t.src=e;var
          r=document.getElementsByTagName("script")[0];
          r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
          pintrk('load', '2613337308276', {em: '<user_email_address>'});
          pintrk('page');
          `}
        </Script>
        <Script
          id="gtm-layer"
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-M3GRWQG3R0"
        >{`
window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-M3GRWQG3R0');;
`}</Script>{" "}
        <noscript>
          <img
            height="1"
            width="1"
            style={{display: "none"}}
            alt=""
            src="https://ct.pinterest.com/v3/?event=init&tid=2613337308276&pd[em]=<hashed_email_address>&noscript=1"
          />
        </noscript>
        <BookingProvider>
          <Suspense fallback={<div>loading...</div>}>
            <Component {...pageProps} />
          </Suspense>
        </BookingProvider>
      </ThemeProvider>
    </>
  );
}

export default BookingApp;
